var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!_vm.isLoading)?_c('div',{key:_vm.localeKey,staticClass:"app",style:(_vm.style)},[_c('router-view'),(_vm.footerData)?_c('Footer',{attrs:{"data":_vm.footerData},on:{"locale":_vm.onLocale}}):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }